export class CountryPhoneDto {
    constructor(id, countryName, countryCode, phoneNumber) {
        this.id = id;
        this.countryName = countryName;
        this.countryCode = countryCode;
        this.phoneNumber = phoneNumber;
    }
}